var render = function render(){var _vm=this,_c=_vm._self._c;return _c('re-form-field',_vm._g(_vm._b({on:{"dirty":_vm.onDirty},model:{value:(_vm.$v.fields.value.$model),callback:function ($$v) {_vm.$set(_vm.$v.fields.value, "$model", $$v)},expression:"$v.fields.value.$model"}},'re-form-field',_vm.fieldAttrs,false),_vm.selectedListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }